import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "..";

export interface Address {
  country_name: string;
  state_name: string;
  city_name: string;
  postal_code: string;
  street_no_one: string;
  street_no_two: string;
  longitude: string;
  latitude: string;
}

export type UserRole = "traveller" | "sender" | "";

export interface User {
  user_id?: number;
  auth0_id?: string;
  full_name?: string;
  birthday?: string;
  phone_number?: string | null;
  user_role?: UserRole;
  address?: Address;
  profile_image?: string;
  email?: string;
  name?: string;
  picture?: string;
  sub?: string;
}

interface UserState {
  user: User | null;
  isAuthenticated: boolean;
  token: string | null;
}

const initialState: UserState = {
  user: null,
  isAuthenticated: false,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = { ...state.user, ...action.payload };
      state.isAuthenticated = true;
    },
    updateUserProfile(state, action: PayloadAction<Partial<User>>) {
      state.user = { ...state.user, ...action.payload };
    },
    updateUserAvatar(state, action: PayloadAction<string>) {
      if (state.user) {
        state.user.profile_image = action.payload;
        if (state.user.picture) {
          state.user.picture = action.payload;
        }
      }
    },
    updateUserRole(state, action: PayloadAction<UserRole>) {
      if (state.user) {
        state.user.user_role = action.payload;
      }
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.token = null;
    },
  },
});

export const {
  setUser,
  updateUserProfile,
  updateUserRole,
  updateUserAvatar,
  setToken,
  logout,
} = userSlice.actions;

export const selectUser = (state: RootState) => state.user.user;
export const selectToken = (state: RootState) => state.user.token;
export const selectIsAuthenticated = (state: RootState) => state.user.isAuthenticated;

export default userSlice.reducer;